import * as React from 'react';

export interface ErrorContactComponentProps {
  error: boolean;
  errorMessage: {};
}

const messageValues: { [s: string]: string; } = {
  serverConnection: 'serverConnection',
  name: 'name',
  surname: 'surname',
  email: 'email',
  message: 'message',
  checkTerms: 'checkTerms',
};

const ContactErrorMessagesComponent = (props: ErrorContactComponentProps) => {

  const message = (messages: {}): React.ReactNode => {
    if (Object.keys(messages).lastIndexOf(messageValues.serverConnection) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          {messages[messageValues.serverConnection]}
          </div>
      );
    }

    if (typeof messages === 'object' && Object.keys(messages).lastIndexOf(messageValues.email) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          Debes introducir un email con el formato correcto
      <br/>
      de nuevo
        </div>
    );
    }
    if (typeof messages === 'object' && Object.keys(messages).lastIndexOf(messageValues.name) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          Debes introducir un nombre
        </div>
      );
    }
    if (typeof messages === 'object' && Object.keys(messages).lastIndexOf(messageValues.surname) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          Debes introducir los apellido/s
        </div>
      );
    }
    if (typeof messages === 'object' && Object.keys(messages).lastIndexOf(messageValues.message) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          Debes escribirnos un mensaje
        </div>
      );
    }
    if (typeof messages === 'object' && Object.keys(messages).lastIndexOf(messageValues.checkTerms) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          Debes aceptar los términos y condiciones de uso
        </div>
      );
    } else {
      return;
    }
  };

  return (
    <div>
      {props.error ? message(props.errorMessage) : null}
  </div>
);
};

export default ContactErrorMessagesComponent;



// WEBPACK FOOTER //
// ./src/modules/contact/partials/ContactErrorMessages.component.tsx